import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class PodcastService {
  private rssUrl = 'https://www.spreaker.com/show/4175221/episodes/feed';


  constructor(private http: HttpClient) {}

  getPodcasts() {
    return this.http.get<{feed: any, items: any[]}>(
        `https://api.rss2json.com/v1/api.json?rss_url=${this.rssUrl}`
    );
  }
}
